import AjaxArchive from "../classes/AjaxArchive";

function init() {
	const ajaxArchives = document.querySelectorAll('.js-ajax-archive');

	if (ajaxArchives) {
		ajaxArchives.forEach(element => {
			const instance = new AjaxArchive(element);
		});
	}
};

export default init;